import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";
import Leftsidebar from "../leftsidebar";

const LayoutHOC = (props) => {
  const history = useHistory();

  const currentPath = window.location.pathname;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  useEffect(() => {
    if (history.location.search) {
      const urlParams = new URLSearchParams(history.location.search);
      const id = urlParams.get("id");
      const taskId = urlParams.get("taskId");
      history.replace({
        pathname: history.location.pathname,
        state: { id: id ? id : "", taskId: taskId ? taskId : "" },
      });
    }
    return null;
  }, [history.location.search]);

  return (
    <>
      {currentPath !== "/" && (
        <section className="content-block">
          {props.pageLevel === 2 ? (
            <React.Fragment>
              <Leftsidebar
                supplier
                completedProgress={100}
                completedCompanyDetails
                completedScopeofSupply
                completedContactReference
                completedBanking
                completedCertificates
                disableBlock={props.disableBlock}
                handleToggleSidebar={handleToggleSidebar}
                toggled={toggled}
              />
              <div className="container-fluid block-pads">
                <Header
                  titleText={props.titleText}
                  linkToBack={props.linkToBack}
                  supplier
                  disableBlock={props.disableBlock}
                  handleToggleSidebar={handleToggleSidebar}
                />
                {props.children}
                <Footer />
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Leftsidebar
                pageLevel={1}
                showMenu={true}
                disableBlock={props.disableBlock}
                handleToggleSidebar={handleToggleSidebar}
                toggled={toggled}
              />
              <div className="container-fluid block-pads">
                <Header
                  titleText={props.titleText}
                  linkToBack={props.linkToBack}
                  ref={props.headerRef}
                  disableBlock={props.disableBlock}
                  handleToggleSidebar={handleToggleSidebar}
                />
                {props.children}
                <Footer />
              </div>
            </React.Fragment>
          )}
        </section>
      )}
    </>
  );
};

export default LayoutHOC;
